import React from 'react';
import Icon from '../../../components/AppIcon';

import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const PreferenceControls = ({ preferences, onPreferenceChange }) => {
  const dietaryOptions = [
    'Vegetarian', 'Vegan', 'Gluten-Free', 'Dairy-Free', 
    'Nut-Free', 'Keto', 'Paleo', 'Low-Carb', 'Halal', 'Kosher'
  ];

  const cuisineOptions = [
    'Italian', 'Mexican', 'Asian', 'Mediterranean', 
    'American', 'Indian', 'Middle Eastern', 'Japanese'
  ];

  const budgetOptions = [
    { value: 'budget', label: 'Budget-Friendly' },
    { value: 'moderate', label: 'Moderate' },
    { value: 'premium', label: 'Premium' }
  ];

  const toggleArrayItem = (array, item) => {
    if (array?.includes(item)) {
      return array?.filter(i => i !== item);
    }
    return [...array, item];
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-md p-4 md:p-6 mb-6">
      <div className="flex items-center gap-2 mb-6">
        <Icon name="Sliders" size={20} color="var(--color-primary)" />
        <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Customize Your Preferences
        </h2>
      </div>
      <div className="space-y-6">
        {/* Dietary Restrictions */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-3">
            Dietary Restrictions
          </label>
          <div className="flex flex-wrap gap-2">
            {dietaryOptions?.map((option) => (
              <button
                key={option}
                onClick={() => onPreferenceChange(
                  'dietaryRestrictions',
                  toggleArrayItem(preferences?.dietaryRestrictions, option)
                )}
                className={`px-3 py-1.5 rounded-full text-sm font-medium transition-smooth ${
                  preferences?.dietaryRestrictions?.includes(option)
                    ? 'bg-primary text-white' :'bg-muted text-muted-foreground hover:bg-muted/80'
                }`}
              >
                {option}
              </button>
            ))}
          </div>
        </div>

        {/* Cuisine Preferences */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-3">
            Cuisine Preferences
          </label>
          <div className="flex flex-wrap gap-2">
            {cuisineOptions?.map((option) => (
              <button
                key={option}
                onClick={() => onPreferenceChange(
                  'cuisinePreferences',
                  toggleArrayItem(preferences?.cuisinePreferences, option)
                )}
                className={`px-3 py-1.5 rounded-full text-sm font-medium transition-smooth ${
                  preferences?.cuisinePreferences?.includes(option)
                    ? 'bg-accent text-white' :'bg-muted text-muted-foreground hover:bg-muted/80'
                }`}
              >
                {option}
              </button>
            ))}
          </div>
        </div>

        {/* Caloric Target and Meals Per Day */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Daily Caloric Target
            </label>
            <Input
              type="number"
              value={preferences?.caloricTarget}
              onChange={(e) => onPreferenceChange('caloricTarget', parseInt(e?.target?.value) || 2000)}
              min="1000"
              max="5000"
              step="100"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Meals Per Day
            </label>
            <Select
              value={preferences?.mealsPerDay}
              onChange={(e) => onPreferenceChange('mealsPerDay', parseInt(e?.target?.value))}
            >
              <option value={3}>3 Meals</option>
              <option value={4}>4 Meals</option>
              <option value={5}>5 Meals</option>
              <option value={6}>6 Meals</option>
            </Select>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Budget
            </label>
            <Select
              value={preferences?.budget}
              onChange={(e) => onPreferenceChange('budget', e?.target?.value)}
            >
              {budgetOptions?.map((option) => (
                <option key={option?.value} value={option?.value}>
                  {option?.label}
                </option>
              ))}
            </Select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreferenceControls;